<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="12">
          <a-col  :md="6" :sm="8">
            <a-form-item :label="$t(I18N_KEY.REPAYREPORT + 'requestDate')" :labelCol="{span: 6}" :wrapperCol="{span: 14, offset: 1}">
               <a-range-picker
                  v-model="queryParam.examineDate"
                  format="YYYY-MM-DD" />
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="searchQuery('', '')" icon="search" style="margin-left: 8px">{{ $t('search') }}</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
      <a-table
        ref="table"
        rowKey="id"
        size="middle"
        :columns="columns"
        :rowClassName="rowClassName"
        :dataSource="dataSource"
        :pagination="false"
        :scroll="{x:1000}"
        :loading="loading"
        bordered
        @change="handleTableChange">
        <Dict slot="approvalStatus" slot-scope="text" :dict-code="DICT_CODE.ORDER_STATUS">{{ text }}</Dict>
      </a-table>

    </div>
  </a-card>
</template>

<script>
import { filterObj } from '@/utils/util'
import {getApplist, getRepaymentYYReportForBeginDate} from '@/webpublicapi/order'
import exportFile from '@/webpublicapi/exportFile'
import Dict from '../modules/Dict';
import DictSelect from '../modules/DictSelect';
import moment from 'moment'
const I18N_KEY = {
  ORDER: 'order.',
  CUSTOMER: 'customer.',
  APPROVAL: 'approval.',
  REPAYREPORT: 'repayReport.',
}
export default {
  name: 'repayReport',
  components: {
    Dict,
    DictSelect,
  },
  data () {
    return {
      I18N_KEY,
      toggleSearchStatus:false,
      visible: false,
      exportParams: '',
      // Pagination params
      form: {
        pageNum: 1,
        pageSize: 30,
      },
      total: 0,
      appList: [],
      dataSource: [],
      // Query conditions
      queryParam: {
        "examinerName":"",
        "appssid":"",
        "duration":"",
        "examineDate":undefined,
      },
      loading: false,
      isorter: {
        column: 'createTime',
        order: 'desc'
      },
      labelCol: {
        xs: { span: 8 },
        sm: { span: 5 }
      },
      wrapperCol: {
        xs: { span: 16 },
        sm: { span: 19 }
      }
    }
  },
  computed: {
    columns () {
      return [
        {
          title: this.$t(I18N_KEY.REPAYREPORT + 'curDate'),
          align: 'left',
          width: '100px',
          dataIndex: 'curDate'
        },
        {
          title: 'Due Count',
          align: 'left',
          width: '100px',
          dataIndex: 'repayCurCount'
        },
        {
          title: 'New Customer Due',
          align: 'left',
          width: '100px',
          dataIndex: 'repayCurCountNew'
        },
        {
          title: 'Old Customer Due',
          align: 'left',
          width: '100px',
          dataIndex: 'repayCurCountOld'
        },
        {
          title: 'First Overdue',
          align: 'left',
          width: '100px',
          dataIndex: 'firstOverDueRate'
        },
        {
          title: 'New Customer First Overdue',
          align: 'left',
          width: '100px',
          dataIndex: 'firstOverDueRateNew'
        },
        {
          title: 'Old Customer First Overdue',
          align: 'left',
          width: '100px',
          dataIndex: 'firstOverDueRateOld'
        },
        {
          title: 'Overdue',
          align: 'left',
          width: '100px',
          dataIndex: 'overTotalCount'
        },
        {
          title: 'New Customer Overdue',
          align: 'left',
          width: '100px',
          dataIndex: 'overTotalCountNew'
        },
        {
          title: 'Old Customer Overdue',
          align: 'left',
          width: '100px',
          dataIndex: 'overTotalCountOld'
        },
        {
          title: 'T0Recovery Rate',
          align: 'left',
          width: '100px',
          dataIndex: 'T0colbackRate'
        },
        {
          title: 'T0 Old Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'T0colbackRateOld'
        },
        {
          title: 'T0 New Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'T0colbackRateNew'
        },
        ,
        {
          title: 'Overall Recovery Rate',
          align: 'left',
          width: '100px',
          dataIndex: 'colbackRate'
        },
        {
          title: 'New Customer Overall Recovery Rate',
          align: 'left',
          width: '115px',
          dataIndex: 'colbackRateNew'
        },
        {
          title: 'Old Customer Overall Recovery Rate',
          align: 'left',
          width: '115px',
          dataIndex: 'colbackRateOld'
        },
        {
          title: 'S1Recovery Rate',
          align: 'left',
          width: '100px',
          dataIndex: 'S1colbackRate'
        },
        {
          title: 'S1 New Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'S1colbackRateNew'
        },
        {
          title: 'S1 Old Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'S1colbackRateOld'
        },
        {
          title: 'S2Recovery Rate',
          align: 'left',
          width: '100px',
          dataIndex: 'S2colbackRate'
        },
        {
          title: 'S2 New Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'S2colbackRateNew'
        },
        {
          title: 'S2 Old Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'S2colbackRateOld'
        },
        {
          title: 'S3Recovery Rate',
          align: 'left',
          width: '100px',
          dataIndex: 'S3colbackRate'
        },
        {
          title: 'S3 New Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'S3colbackRateNew'
        },
        {
          title: 'S3 Old Customer Recovery Rate',
          align: 'left',
          width: '110px',
          dataIndex: 'S3colbackRateOld'
        }
      ]
    }
  },
  created () {
    this.loadData(1, '', '');
    getApplist().then(res => {
      this.appList = res.data || [];
    })
  },
  methods: {
    handleToggleSearch(){
      this.toggleSearchStatus = !this.toggleSearchStatus;
    },
    searchQuery (arg, arg2) {

      this.loadData(1, arg, arg2)
    },
    loadData (arg,arg2,arg3) {
      // Load data If params passed1Then load first page content
      if (arg === 1) {
        this.form.pageNum = 1
      }
      this.loading = true
      var params = this.getQueryParams(arg2, arg3)// Query conditions
      this.exportParams = Object.entries(params).map(([key, value]) => key + '=' + value);
      getRepaymentYYReportForBeginDate(Object.assign({}, params)).then((res)=>{
        if(res.code===1000){
          this.dataSource = res.data || [];
        }else{
          this.total = 0
          this.dataSource = []
          this.$message.error(res.msg)
        }
        this.loading = false
      }).catch(e => {
            this.loading = false;
            this.$message.error(e.message);
      })
    },
    downLoadData () {
      const file = {
        fileUrl: '/api/web/statistics/platform/repaymentReportExcel?' + this.exportParams,
        fileName: 'report.xls',
      }
      this.loading = true;
      exportFile(file).catch(e => {
          this.$message.error(e.message);
      }).finally(() => {
          this.loading = false;
      })
    },
    transformTime (time) {
      return moment(time).format('YYYY-MM-DD')
    },
    transformStringToLow (str) {
       return str && str.toLocaleLowerCase();
    },
    getQueryParams (arg, arg3) {
      const { examineDate } = this.queryParam;
      const data = {
          ...this.queryParam,
          startDate: examineDate && this.transformTime(examineDate[0]),
          endDate: examineDate && this.transformTime(examineDate[1]),
          loanCount: arg,
          // orderType: arg3,
      }
      delete data.examineDate;
      return filterObj(data)
    },
    handleTableChange (pageNum, pageSize) {
        this.form.pageNum = pageNum;
        this.form.pageSize = pageSize;
        this.loadData();
    },
    // Reset dictionary type search box content
    searchReset () {
      var that = this
      that.queryParam.examinerName = ''
      that.queryParam.examineDate = undefined;
      that.loadData(this.form.pageNum)
    },
    rowClassName(record,index){
      var date = new Date(record.curDate);
      var day = date.getTime() / 24 / 60 / 60 / 1000 + 3;
      if((day % 7) + 1 == 7){
        return 'table_weekendColor';
      }
      return '';
    }
  }
}
</script>

<style lang="less" scoped>
 @import "~@/assets/less/common.less";

</style>
